import { api } from '@/api'
import { Period } from '@/ui-kit'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export function useFetchUserUptimePoints(period: Period): UseQueryResult<Record<Period, Record<string, string>>> {
  return useQuery({
    queryKey: ['useFetchUserUptimePoints', period],
    queryFn: () => api.get(`/user/stats/uptime-points?period=${period}`),
    retry: 0
  })
}
